module.exports = __webpack_public_path__ + "img/demo.a4f13f49.png";